import { handleize } from './handleize';
const notNumericReg = /floating|framed|poster|core/i;
export const compareLayoutsByPrecedence = (a, b) => {
    const handleA = handleize(a);
    const handleB = handleize(b);
    const numA = Number(handleA.replace(/\D/g, ''));
    const numB = Number(handleB.replace(/\D/g, ''));
    if (numA === 0 && !notNumericReg.test(handleA))
        return 1;
    if (numB === 0 && !notNumericReg.test(handleB))
        return -1;
    if (handleA.includes('art-print'))
        return 1;
    if (handleB.includes('art-print'))
        return -1;
    if (handleA.includes('poster'))
        return 1;
    if (handleB.includes('poster'))
        return -1;
    if (handleA.includes('framed'))
        return 1;
    if (handleB.includes('framed'))
        return -1;
    if (handleA.includes('floating'))
        return 1;
    if (handleB.includes('floating'))
        return -1;
    if (handleA.includes('core'))
        return 1;
    if (handleB.includes('core'))
        return -1;
    if (numA === 1)
        return 1;
    if (numB === 1)
        return -1;
    return numA - numB;
};
